import { createTheme } from '@mui/material/styles';
export default createTheme({
  palette: {
    primary: {
      main: '#38634B',
      dark: '#243F32',
      light: '#E8F0E9',
      contrastText: '#FFFFFF'
    },
    secondary: { main: '#AD5147', light: '#F9EEEA' },
    background: { default: '#F5F7F3', paper: '#FFFFFF' },
    text: { primary: '#24382E', secondary: '#617067' },
    divider: '#E2E8DF',
    success: { main: '#38634B' },
    info: { main: '#547660', light: '#EEF3ED' },
    warning: { main: '#9A681D' },
    error: { main: '#B33D3D' }
  },
  shape: { borderRadius: 14 },
  typography: {
    fontFamily: '"Segoe UI", system-ui, sans-serif',
    h1: { fontSize: '1.65rem', fontWeight: 700, letterSpacing: '-.025em' },
    h2: { fontSize: '1.65rem', fontWeight: 700 },
    h3: { fontSize: '1.6rem', fontWeight: 650 },
    h4: { fontSize: '1.65rem', fontWeight: 700, letterSpacing: '-.025em' },
    h5: { fontSize: '1.4rem', fontWeight: 650 },
    h6: { fontSize: '1rem', fontWeight: 650 },
    button: { textTransform: 'none', fontWeight: 600, letterSpacing: 0 }
  },
  components: {
    MuiPagination: {
      defaultProps: {
        getItemAriaLabel: (type, page, selected) =>
          type === 'page'
            ? `${selected ? 'Page actuelle' : 'Page'} ${page}`
            : {
                first: 'Première page',
                last: 'Dernière page',
                next: 'Page suivante',
                previous: 'Page précédente'
              }[type] || type
      }
    },
    MuiTablePagination: {
      defaultProps: {
        labelRowsPerPage: 'Lignes par page',
        labelDisplayedRows: ({ from, to, count }) =>
          `${from}–${to} sur ${count === -1 ? 'plusieurs' : count}`,
        getItemAriaLabel: type =>
          ({
            first: 'Première page',
            last: 'Dernière page',
            next: 'Page suivante',
            previous: 'Page précédente'
          })[type]
      }
    },
    MuiAutocomplete: {
      defaultProps: {
        openText: 'Ouvrir',
        closeText: 'Fermer',
        clearText: 'Effacer',
        noOptionsText: 'Aucun résultat'
      }
    },
    MuiTabs: {
      styleOverrides: { root: { minHeight: 44 }, indicator: { height: 2 } }
    },
    MuiTab: {
      styleOverrides: {
        root: { minHeight: 44, fontSize: 13, padding: '10px 16px' }
      }
    },
    MuiPaper: {
      defaultProps: { elevation: 0 },
      styleOverrides: { root: { border: '1px solid #E2E8DF' } }
    },
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: { root: { borderRadius: 10, minHeight: 38 } }
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          background: '#F6F8F4',
          color: '#617067',
          fontSize: 12,
          fontWeight: 600
        },
        root: { borderColor: '#E2E8DF', padding: '14px 18px' }
      }
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          '&:last-child td': { borderBottom: 0 },
          '&:hover': { background: '#FAFCF8' }
        }
      }
    },
    MuiChip: {
      styleOverrides: {
        root: { borderRadius: 7, fontWeight: 550 },
        colorPrimary: { background: '#E8F0E9', color: '#243F32' }
      }
    },
    MuiDialog: {
      styleOverrides: {
        paper: { borderRadius: 20, boxShadow: '0 24px 80px #243F3233' }
      }
    },
    MuiDialogTitle: {
      styleOverrides: { root: { padding: '22px 24px', fontWeight: 650 } }
    },
    MuiDialogActions: {
      styleOverrides: {
        root: { padding: '16px 24px', borderTop: '1px solid #E2E8DF' }
      }
    },
    MuiTextField: { defaultProps: { size: 'small' } },
    MuiOutlinedInput: {
      styleOverrides: { root: { background: '#FFFFFF', borderRadius: 10 } }
    },
    MuiTooltip: { defaultProps: { arrow: true } }
  }
});
